import request from '../axios/axios.js'


export const save_data = (par) => {
    return request({
        url: '/registra/2019',
        method: 'post',
        data: par,
    })
};


export const save_data_2024 = (par) => {
    return request({
        url: '/registra/2024',
        method: 'post',
        data: par,
    })
};